import i18n from '@thoughtspot/i18n';
function getTranslatedInfoForMessageCode(code, defaultErrorMessage) {
    if (!code && !defaultErrorMessage)
        return {
            summary: undefined,
            action: undefined,
            detail: undefined,
        };
    const defaultMessage = defaultErrorMessage || 'error.validation.default';
    return {
        summary: i18n.exists(`msg_code.${code}.summary`)
            ? `msg_code.${code}.summary`
            : defaultMessage,
        action: i18n.exists(`msg_code.${code}.action`)
            ? `msg_code.${code}.action`
            : undefined,
        detail: i18n.exists(`msg_code.${code}.detail`)
            ? `msg_code.${code}.detail`
            : undefined,
    };
}
export { getTranslatedInfoForMessageCode };
//# sourceMappingURL=error-strings-mapping.js.map